<template>
  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">
        <p>
          Keep an eye on your inbox! Great beer coming to you soon!
        </p>
        <img class="pure-u-1" src="../../assets/images/ale_apothecary_join_us.jpg">
        <p>
          If you have any questions, concerns or comments, please email
          <a href="mailto:support@tavour.com">support@tavour.com</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../lib/store';

export default {
  name: 'SuccessAleApothecary',
  created() {
    /* global ga fbq */
    ga('send', 'pageview', `/${store.get('aleApothecary')}/Success`);

    store.clear();
  },
};
</script>

<style>
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// SuccessAleApothecary.vue?90ebcb26